import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import { TranslateModule } from '@ngx-translate/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { EntityDataComponent } from './components/entity-data/entity-data.component';
import { BrowserModule } from '@angular/platform-browser';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DelimitationViewComponent } from './components/delimitation-view/delimitation-view.component';
import { AnnexesViewComponent } from './components/annexes-view/annexes-view.component';
import { MatIconModule } from '@angular/material/icon';
import { InovaCorePipesModule, UserLanguagePipe } from 'inova-front-core/helpers/pipes';



@NgModule({
  declarations: [EntityDataComponent, DelimitationViewComponent, AnnexesViewComponent],
  imports: [
    CommonModule,
    TranslateModule,
    MatButtonModule,
    MatDialogModule,
    MatTooltipModule,
    MatIconModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    InovaCorePipesModule,
  ],
  exports:[EntityDataComponent, DelimitationViewComponent,AnnexesViewComponent],
  providers:[UserLanguagePipe]
})
export class InovaCoreEntityDataModule { }
